import { createContext, useContext, useEffect, useState } from 'react'
import { useLocation, useParams } from 'react-router'
import {
  HOME_PATH,
  NEW_SEO,
  SELECTION_STEP_PATH_LOADED
} from 'routes/constants.routes'
import { LocalStorageService, parseJson } from 'lib/utils'
import { ClientService, SalesService } from 'lib/api'
import { useResErrors, useRoutes } from 'hooks'
import { FilterStoreProvider } from 'context/SelectionStore/Manager/FilterStoreProvider.mager'
import {
  ACTIVE,
  getPrevStepByStatus,
  HOLD,
  PAYMENT,
  STEPPER_STATUS
} from 'constants/deals'
import useSeoApis from 'hooks/useSeoApis'
import { useModalbar } from 'modules/Modalbar'
import { useSnackbar } from 'notistack'

export const SelectionStoreContext = createContext({
  store: {},
  func: {}
})
const INITIAL_RSE = {
  gender: null,
  visitType: null,
  budget: null,
  approximateBuy: null,
  prepayment: 0,
  carOwnership: null,
  creditProcent: 0,
  paymentType: null,
  additionalInfo: '',
  isTradeIn: false
}

export const SelectionStoreProvider = props => {
  const { id: saleIdParam, step } = useParams()
  const {
    seoLoading,
    startTicket,
    rejectClient,
    reInviteClient,
    getStatus,
    hasActiveTicket
  } = useSeoApis()
  const { callModalbar } = useModalbar()
  const { standardCheck, silentCheck } = useResErrors()
  const { enqueueSnackbar } = useSnackbar()
  const { goTo, push } = useRoutes()
  const location = useLocation()
  const [loading, setLoading] = useState(false)
  const [initLoad, setInitLoad] = useState(false)
  const [client, setClient] = useState({
    phoneNumber: '',
    firstName: '',
    language: ''
  })
  const [commentsRSE, setCommentsRSE] = useState(INITIAL_RSE)
  const [comments, setComments] = useState([])
  const [sale, setSale] = useState(null)
  const [upSale, setUpSale] = useState(null)
  const [selectedCars, setSelectedCars] = useState([])
  const [selectedCarForSale, setSelectedCarForSale] = useState(null)
  const [demonstratedCars, setDemonstratedCars] = useState([])
  const [tiresId, settiresId] = useState(null)
  useEffect(() => {
    if (location.pathname.includes('undefined')) {
      return push(HOME_PATH)
    }
    if (sale && ['120', '130'].includes(sale?.saleStatusTrack?.code)) {
      goTo(SELECTION_STEP_PATH_LOADED(saleIdParam)[step])
    }
    if (step === NEW_SEO) {
      initSale()
    } else {
      getPreviousSelection()
    }
    return () => {}
  }, [])

  const initSale = async () => {
    setInitLoad(true)
    if (saleIdParam) {
      await getSaleById(saleIdParam)
    }
    setInitLoad(false)
  }
  const getPreviousSelection = async () => {
    setInitLoad(true)

    if (saleIdParam && step) {
      await getSaleById(saleIdParam)
      goTo(SELECTION_STEP_PATH_LOADED(saleIdParam)[step])
    } else if (saleIdParam) {
      await getSaleById(saleIdParam)
    }
    setInitLoad(false)
  }

  const getSaleById = async id => {
    setLoading(true)
    await SalesService.getByIdForSelection(id).then(res =>
      standardCheck(
        res,
        () => {
          setSale(res.data)
          setClient(res.data?.client)
          setCommentsRSE(parseJson(res.data?.commentsRSE, INITIAL_RSE))
          setSelectedCars(res?.data.selectedCars || [])
          setDemonstratedCars(res?.data?.demonstratedCars || [])
          setSelectedCarForSale(res?.data?.selectedCarsForSale?.[0] || null)
        },
        {
          onFail: () => {
            goTo(HOME_PATH)
          }
        }
      )
    )
    setLoading(false)
  }
  const startSelection = async () => {
    setLoading(true)
    const getActiveTicket = await hasActiveTicket({})
    if (getActiveTicket === 4) {
      return await updateSale(
        {
          isNewSeo: false,
          commentsRSE: JSON.stringify(commentsRSE),
          saleStatus: { code: ACTIVE }
        },
        () => {
          setLoading(false)
          updateStatusTrack(STEPPER_STATUS[0], () =>
            goTo(SELECTION_STEP_PATH_LOADED(saleIdParam)[0])
          )
        }
      )
    }

    await startTicket({
      onSuccess: async ({ data }) => {
        if ([8, 9].includes(data.code)) {
          enqueueSnackbar(data.message, {
            variant: 'success'
          })
          await updateSale(
            {
              isNewSeo: false,
              commentsRSE: JSON.stringify(commentsRSE),
              saleStatus: { code: ACTIVE }
            },
            () => {
              updateStatusTrack(STEPPER_STATUS[0], () =>
                goTo(SELECTION_STEP_PATH_LOADED(saleIdParam)[0])
              )
            }
          )
        } else {
          callModalbar(
            'Проблема SEO ' + data.code,
            data.error + ' startTicket',
            {
              variant: 'error',
              onCloseAction: getStatus({
                onSuccess: ({ data }) =>
                  enqueueSnackbar(data.message, {
                    variant: 'info'
                  })
              })
            }
          )
        }
      },
      onFail: () => {
        setLoading(false)
      }
    })
    setLoading(false)
  }

  const clientRejected = async () => {
    await updateSale({
      clientDeclined: false,
      closedByRop: false,
      saleStatus: { code: HOLD }
    })
    await rejectClient({
      onSuccess: () => {
        goToHome()
      }
    })
  }
  const getAllComments =
    (globalId = sale?.globalId) =>
    async () => {
      await SalesService.getAllComments(globalId).then(res => {
        if (res.status === 200) {
          setComments(res?.data)
        }
      })
    }

  const addComments = async (comment, cb = () => {}) => {
    await SalesService.addSaleComments(sale.id, comment).then(res =>
      standardCheck(res, () => {
        cb()
        getAllComments(sale?.globalId)()
      })
    )
  }

  const updateRseComments = async () => {
    await SalesService.updateSale({
      id: sale?.id,
      commentsRSE: JSON.stringify(commentsRSE)
    }).then(res =>
      standardCheck(res, () => {
        setCommentsRSE(parseJson(res.data.commentsRSE, INITIAL_RSE))
      })
    )
  }

  const updateSale = async (data = {}, cb = () => {}) => {
    await SalesService.updateSale({
      id: sale?.id,
      ...data
    }).then(res =>
      standardCheck(res, () => {
        setUpSale(res.data)
        getSaleById(sale.id)
        cb()
      })
    )
  }

  const clearUpdateSale = async (data = {}, cb = () => {}) => {
    await SalesService.updateSale({
      id: sale?.id,
      ...data
    }).then(res =>
      standardCheck(res, () => {
        settiresId(res.data.tiresId)
        cb()
      })
    )
  }

  const updateStatusTrack = async (code = 0, cb = () => {}) => {
    if (code === 20) {
      await SalesService.updateSaleByGlobalId({
        globalId: sale?.globalId,
        creditRequests: true
      })
    }

    await SalesService.updateStatusTrack(sale.id, Number(code)).then(res => {
      silentCheck(res, cb, {
        onFail: cb
      })
      if (code === 110) {
        if (res?.data) {
          enqueueSnackbar('Успешно отправлено на согласование спп', {
            variant: 'success'
          })
        }
        if (res?.err) {
          enqueueSnackbar(`${res?.err} ${res?.msg}`, {
            variant: 'error'
          })
        }
      }
    })
  }

  const carfinUpdateStatusTrack = async (code = 0, cb = () => {}) => {
    if (code === 10) {
      await SalesService.updateSaleByGlobalId({
        globalId: sale?.globalId,
        creditRequests: true
      })
    }

    await SalesService.carfinUpdateStatusTrack(sale.id, Number(code)).then(
      res =>
        silentCheck(res, cb, {
          onFail: cb
        })
    )
  }

  const onChangeSeoClientFields = (values = {}) => {
    setClient(prev => ({
      ...prev,
      ...values
    }))
  }

  const onChangeRse = (values = {}) => {
    setCommentsRSE(prev => ({
      ...prev,
      ...values
    }))
  }

  const goPrevStep = () => {
    if (step !== NEW_SEO && Number(step) !== 0) {
      const nextStep = Number(step) - 1
      LocalStorageService.setCurrentStep(nextStep)
      if (!!saleIdParam) {
        updateStatusTrack(STEPPER_STATUS[nextStep])
        return goTo(SELECTION_STEP_PATH_LOADED(saleIdParam)[nextStep])
      }
    }
  }

  const goNextStep = () => {
    const nextStep = Number(step) + 1
    if (nextStep && nextStep !== 4) {
      LocalStorageService.setCurrentStep(nextStep)

      if (!!saleIdParam) {
        updateStatusTrack(STEPPER_STATUS[nextStep])
        return goTo(SELECTION_STEP_PATH_LOADED(saleIdParam)[nextStep])
      }
    }
  }
  const handleSelectCar = car => {
    if (selectedCars.length === 0) {
      setSelectedCars([car])
    } else {
      const selectedCarVins = selectedCars.map(c => c.vin)
      if (!selectedCarVins.includes(car.vin)) {
        setSelectedCars([...selectedCars, car])
      } else {
        setSelectedCars(selectedCars.filter(el => el?.vin !== car.vin))
      }
    }
  }

  const updateSelectedCars = async () => {
    await SalesService.updateSelectionOfCars({
      id: sale?.id,
      selectedCarVins: selectedCars.map(c => c.vin)
    }).then(res =>
      standardCheck(res, async () => {
        await updateSale({}, async () => {
          await sendToFavorites()
          goNextStep()
        })
      })
    )
  }

  const sendToFavorites = async () => {
    await SalesService.sendToFavorites(sale?.id).then(res =>
      silentCheck(res, async () => {
        if (res?.data) {
          enqueueSnackbar('Отправлено в избранное', {
            variant: 'success'
          })
        }
      })
    )
  }

  const sendInspectionResult = async (car, data = {}) => {
    let isOk = false
    await SalesService.updateSaleCar({
      id: car.id,
      ...data
    }).then(res =>
      standardCheck(res, async () => {
        isOk = true
        await SalesService.updateSelectionOfCars({
          id: sale?.id,
          demonstratedCarsVins: [
            car?.vin,
            ...demonstratedCars.map(c => c.vin)?.filter(v => v !== car?.vin)
          ]
        }).then(res =>
          standardCheck(res, async () => {
            isOk = true
            await getSaleById(sale.id)
          })
        )
      })
    )
    return isOk
  }

  const handleSelectCarForSale = async car => {
    let isOk = false
    if (selectedCarForSale) {
      await SalesService.updateSaleCar({
        id: selectedCarForSale.id,
        selectedForSale: false
      })
    }
    setSelectedCarForSale(car)
    await SalesService.updateSaleCar({
      id: car.id,
      selectedForSale: true
    }).then(res =>
      standardCheck(res, async () => {
        goNextStep()
        if (!!selectedCarForSale && car?.id !== selectedCarForSale?.id) {
          updateSale({
            sppApprove: false
          })
        }
        isOk = true
        await getSaleById(sale.id)
      })
    )
    return isOk
  }

  const sendToPaperWork = async (saleType, paymentType) => {
    setLoading(true)
    await updateSale(
      {
        saleType,
        paymentType,
        clientDeclined: false,
        saleStatus: { code: PAYMENT }
      },
      () => {
        goToHome()
      }
    )
    setLoading(false)
  }
  const pauseWl = async () => {
    setLoading(true)
    await updateSale(
      {
        clientDeclined: false,
        saleStatus: { code: HOLD }
      },
      () => {
        goToHome()
      }
    )
    setLoading(false)
  }
  const missedWl = async result => {
    setLoading(true)
    await updateSale(
      {
        closedByRop: false,
        clientDeclined: true,
        result,
        saleStatus: { code: HOLD }
      },
      async () => {
        await updateStatusTrack(80)
        goToHome()
      }
    )
    setLoading(false)
  }
  const goToHome = async () => {
    await LocalStorageService.removeSelectionId()
    await LocalStorageService.removeCurrentStep()
    push(HOME_PATH)
  }

  const sendDiscountValue = async (data, isBonus = false) => {
    await SalesService.updateSaleCar({
      id: sale.selectedCarsForSale?.[0]?.id,
      discountValue: parseFloat(data.discountValue),
      discountAmount: parseFloat(data.discountAmount) || 0,
      discountMargin: parseFloat(data.discountMargin) || 0,
      discountReason: data.discountReason,
      discountApprovedByRop: null,
      discountPhotos: data.discountPhotos,
      marginReason: data?.marginReason
    }).then(res =>
      standardCheck(res, async () => {
        if (!isBonus) {
          await updateStatusTrack(90)
        }
        if (!!data.tradeInCarVins?.length || data.certNo) {
          await updateSale(
            !!data.tradeInCarVins?.length
              ? {
                  certNo: data.certNo,
                  tradeInCarVins: data.tradeInCarVins
                }
              : {
                  certNo: data.certNo
                }
          )
        } else {
          await getSaleById(sale.id)
        }
      })
    )
  }
  const reAssignActiveSale = async (phone, cb = () => {}) => {
    setLoading(true)

    await SalesService.reassignActiveSale(phone).then(res =>
      silentCheck(
        res,
        () => {
          if (res?.data?.id) {
            const sale = res.data
            const step = getPrevStepByStatus(
              sale?.saleStatus?.code,
              sale?.saleStatusTrack?.trackStatus?.code
            )

            goTo(SELECTION_STEP_PATH_LOADED(res.data.id)[step || 0])
          } else {
            cb()
          }
        },
        {
          onFail: cb
        }
      )
    )
    setLoading(false)
  }
  const createSale = async () => {
    setLoading(true)
    await ClientService.createClient({
      firstName: client?.firstName,
      phoneNumber: client?.phoneNumber?.toPhone(),
      gender: commentsRSE?.gender,
      language: client?.language
    }).then(res =>
      standardCheck(
        res,
        async () => {
          const { id, ...client } = res.data
          setLoading(true)
          await SalesService.createSale({
            client: {
              ...client,
              clientId: id
            },
            isNewSeo: false,
            commentsRSE: JSON.stringify(commentsRSE)
          }).then(res =>
            standardCheck(
              res,
              () => {
                setLoading(false)
                goTo(SELECTION_STEP_PATH_LOADED(res.data.id)[0])
              },
              {
                onFail: () => {
                  setLoading(false)
                }
              }
            )
          )
        },
        {
          onFail: () => {
            setLoading(false)
          }
        }
      )
    )
  }
  const store = {
    seoLoading,
    seoClient: client,
    initLoad,
    commentsRSE,
    sale,
    tiresId,
    demonstratedCars,
    selectedCars,
    loading,
    selectedCarForSale,
    comments,
    upSale,
    step
  }

  const funcs = {
    clearUpdateSale,
    updateStatusTrack,
    carfinUpdateStatusTrack,
    sendDiscountValue,
    reInviteClient,
    addComments,
    clientRejected,
    onChangeSeoClientFields,
    onChangeRse,
    startSelection,
    updateRseComments,
    goPrevStep,
    goNextStep,
    sendToPaperWork,
    handleSelectCar,
    updateSelectedCars,
    sendInspectionResult,
    handleSelectCarForSale,
    pauseWl,
    missedWl,
    updateSale,
    createSale,
    reAssignActiveSale,
    getSaleById,
    getAllComments: getAllComments()
  }

  return (
    <SelectionStoreContext.Provider value={{ store, funcs }}>
      <FilterStoreProvider
        step={step}
        updateSale={clearUpdateSale}
        prevFilter={parseJson(sale?.filteredValue, null)}
        saleId={sale?.id}
      >
        {props.children}
      </FilterStoreProvider>
    </SelectionStoreContext.Provider>
  )
}

export default SelectionStoreProvider

export const useSelectionStore = () => useContext(SelectionStoreContext)

export const withSelectionStore = Component => props =>
  (
    <SelectionStoreContext.Consumer>
      {state => <Component {...props} {...state} />}
    </SelectionStoreContext.Consumer>
  )
